import { useId } from "react"

import { useDroppable } from "shared/lib/drag-and-drop/useDroppable"
import { toPixels } from "shared/lib/layoutUtils"

interface LastIndexDroppableProps {
  height?: number
  index: number
}

/**
 * Droppable area for the last position in the table.
 * Allows dropping items after the last row.
 */
export function LastIndexDroppable({ height, index }: LastIndexDroppableProps) {
  const id = useId()

  const { isOver, setNodeRef } = useDroppable({
    id: `last-index-droppable-${id}`,
    type: "last-index-droppable",
    data: undefined,
    meta: { index, level: 0, parentID: null, depth: 0 }
  })

  return (
    <div
      ref={setNodeRef}
      style={{
        height: toPixels(height || 16)
      }}
      data-drop-zone=""
      data-drop-zone-hover={isOver ? "" : undefined}
      data-drop-zone-active={isOver ? "" : undefined}
    />
  )
}
